import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  const location = useLocation();

  if (!token) {
    // Redirect to login page, but save the location they were trying to access
    return <Navigate to="/musa/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute;
